import {Routes} from "@angular/router";
import {HomeComponent} from "./pages/home/home";
import {ArticleOverview} from "./pages/admin/article/overview";
import {HomeArticleDetail} from "./pages/article/detail";
import {ContactComponent} from "./pages/contact/contact";
import {RegisterComponent} from "app/pages/register/register";
import {OrdersComponent} from "./pages/orders/orders.component";
import {CheckoutComponent} from "./pages/checkout/checkout.component";
import {RegisterCodeComponent} from "./pages/register/code";
import {ShipmentInfoComponent} from "./pages/shipment/info.component";
import {DetailComponent} from "./pages/orders/detail/detail.component";
import {PurchaseComponent} from "./pages/orders/detail/purchase.component";
import {ArticleResolver} from "./pages/article/resolver.service";

/**
 * Router Setting
 *
 * Write your component (Page) here to load.
 */
export const ROUTES: Routes = [
    // This default is router like '/'.
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    // Lazy loading, you need to create a module file.
    //
    // 1. Find file dashboard.module.lazy at folder dashboard
    // 2. Rename file dashboard.module.lazy to dashboard.module.ts
    // 3. Modify this file
    //    change Line "component: DashboardComponent" to "loadChildren: './dashboard/dashboard.module#DashboardModule'"
    // 4. Modify file app.module.ts
    //    remove line "DashboardComponent," and "import { DashboardComponent } from './pages/dashboard/dashboard.component';"
    //
    // {
    //   path: 'dashboard',
    //   loadChildren: './dashboard/dashboard.module#DashboardModule'
    // },
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'checkout',
        component: CheckoutComponent
    },
    {
        path: 'checkout/:step',
        component: CheckoutComponent
    },
    {
        path: 'article/:id',
        component: HomeArticleDetail,
        resolve: {
            article: ArticleResolver
        }
    },
    {
        path: 'contact',
        component: ContactComponent
    },
    {
        path: 'register',
        component: RegisterComponent
    },
    {
        path: 'code',
        component: RegisterCodeComponent
    },
    {
        path: 'shipment',
        component: ShipmentInfoComponent
    },
    {
        path: 'orders',
        component: OrdersComponent
    },
    {
        path: 'purchase/:id',
        component: PurchaseComponent
    }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts